require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APPROX_STATUSBAR_HEIGHT = void 0;

var _reactNative = require("react-native-web/dist/index");

var expo = global.__expo;
var DEFAULT_STATUSBAR_HEIGHT_EXPO = (expo === null || expo === void 0 ? void 0 : expo.Constants) ? expo.Constants.statusBarHeight : 0;

var APPROX_STATUSBAR_HEIGHT = _reactNative.Platform.select({
  android: DEFAULT_STATUSBAR_HEIGHT_EXPO,
  ios: _reactNative.Platform.Version < 11 ? DEFAULT_STATUSBAR_HEIGHT_EXPO : 0
});

exports.APPROX_STATUSBAR_HEIGHT = APPROX_STATUSBAR_HEIGHT;